import React, { useEffect, useRef, useState } from 'react';
import { X as XIcon, Loader2 } from 'lucide-react';

export const SignaturePad = ({ onCancel, onSave, saving }) => {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [hasInk, setHasInk] = useState(false);

  useEffect(() => {
    const c = ref.current;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio;
    c.height = c.offsetHeight * ratio;
    const ctx = c.getContext('2d');
    ctx.scale(ratio, ratio);
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, c.width, c.height);
    ctx.lineWidth = 2.5;
    ctx.lineCap = 'round';
    ctx.strokeStyle = '#0b2545';
  }, []);

  const pos = (e) => { const r = ref.current.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
  const down = (e) => { drawing.current = true; ref.current.setPointerCapture(e.pointerId); const ctx = ref.current.getContext('2d'); ctx.beginPath(); ctx.moveTo(...pos(e)); };
  const move = (e) => { if (!drawing.current) return; const ctx = ref.current.getContext('2d'); ctx.lineTo(...pos(e)); ctx.stroke(); setHasInk(true); };
  const up = () => { drawing.current = false; };
  const clear = () => { const c = ref.current; const ctx = c.getContext('2d'); ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, c.width, c.height); setHasInk(false); };

  return (
    <div className="fixed inset-0 z-[70] bg-black/60 flex items-end sm:items-center justify-center p-3" data-testid="signature-modal">
      <div className="w-full max-w-lg bg-white rounded-xl p-4">
        <div className="flex items-center justify-between mb-2">
          <h3 className="font-display text-lg font-extrabold text-[color:var(--mv-navy)]">Customer signature</h3>
          <button type="button" onClick={onCancel} className="w-10 h-10 inline-flex items-center justify-center text-slate-500" aria-label="Close"><XIcon className="w-5 h-5" /></button>
        </div>
        <p className="text-xs text-slate-500 mb-2">Ask the customer to sign below to confirm the job was completed.</p>
        <canvas
          ref={ref}
          onPointerDown={down}
          onPointerMove={move}
          onPointerUp={up}
          onPointerLeave={up}
          className="w-full h-48 rounded-md border-2 border-dashed border-slate-300 bg-white touch-none"
          data-testid="signature-canvas"
        />
        <div className="mt-3 flex justify-between gap-2">
          <button type="button" onClick={clear} className="h-11 px-4 rounded-md text-sm font-bold text-slate-600 border border-slate-200" data-testid="signature-clear">Clear</button>
          <button type="button" disabled={!hasInk || saving} onClick={() => onSave(ref.current.toDataURL('image/png'))} className="h-11 px-5 rounded-md bg-[color:var(--mv-navy)] disabled:opacity-50 text-white text-sm font-bold inline-flex items-center gap-1.5" data-testid="signature-save">
            {saving && <Loader2 className="w-4 h-4 animate-spin" />} Save signature
          </button>
        </div>
      </div>
    </div>
  );
};
